module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "focus-warp",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "swipe-wrap",
    attrs: {
      "id": "swiper"
    }
  }, [_c('div', {
    staticClass: "swipe",
    attrs: {
      "id": "swiper-container"
    }
  }, [_c('Carousel', {
    attrs: {
      "autoplay": _vm.setting.autoplay,
      "autoplay-speed": _vm.setting.autoplaySpeed,
      "dots": _vm.setting.dots,
      "radius-dot": _vm.setting.radiusDot,
      "trigger": _vm.setting.trigger,
      "arrow": _vm.setting.arrow,
      "height": 480
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, _vm._l((_vm.list), function(item) {
    return _c('CarouselItem', {
      key: item.key
    }, [_c('router-link', {
      attrs: {
        "to": item.to
      }
    }, [_c('img', {
      staticClass: "img-item",
      attrs: {
        "src": item.atturl
      }
    })])], 1)
  }), 1)], 1)]), _vm._v(" "), _c('banner-right-flow')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b617f04"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/fresh-agricultural/banner.vue
// module id = 1600
// module chunks = 1